import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { budgetStructure } from './budgetConfig';

// @ts-nocheck
export default function AddBudgetCategoryForm({ isOpen, onClose, onSubmit, project, existingCategories, totalAllocated, projectCurrency }) {
    const {
        handleSubmit,
        control,
        formState: { errors },
        reset
    } = useForm({
        defaultValues: {
            category_key: '',
            allocated_budget: ''
        }
    });

    const availableCategories = React.useMemo(() => {
        const existingKeys = existingCategories.map(ec => ec.category_key);
        return budgetStructure.filter(cat => !existingKeys.includes(cat.key));
    }, [existingCategories]);

    const budgetLimit = project.total_budget - totalAllocated;

    const handleFormSubmit = (data) => {
        const categoryInfo = budgetStructure.find(cat => cat.key === data.category_key);
        onSubmit({
            project_id: project.id,
            category_key: data.category_key,
            category_name: categoryInfo.name,
            allocated_budget: Number(data.allocated_budget)
        });
        reset();
    };

    return (
        <Dialog open={isOpen} onOpenChange={(open) => { if (!open) { reset(); onClose(); } }}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Ajouter une catégorie budgétaire</DialogTitle>
                </DialogHeader>
                <form onSubmit={handleSubmit(handleFormSubmit)} className="space-y-4">
                    <div className="space-y-2">
                        <Label htmlFor="category_key">Catégorie</Label>
                        <Controller
                            name="category_key"
                            control={control}
                            rules={{ required: "Veuillez sélectionner une catégorie." }}
                            render={({ field }) => (
                                <Select onValueChange={field.onChange} value={field.value}>
                                    <SelectTrigger>
                                        <SelectValue placeholder="Choisir une catégorie disponible..." />
                                    </SelectTrigger>
                                    <SelectContent>
                                        {availableCategories.map(cat => (
                                            <SelectItem key={cat.key} value={cat.key}>{cat.name}</SelectItem>
                                        ))}
                                    </SelectContent>
                                </Select>
                            )}
                        />
                        {errors.category_key && <p className="text-sm text-red-500">{errors.category_key.message}</p>}
                    </div>
                    <div className="space-y-2">
                        <Label htmlFor="allocated_budget">Budget alloué ({projectCurrency})</Label>
                        <Controller
                            name="allocated_budget"
                            control={control}
                            rules={{
                                required: "Le budget est requis.",
                                validate: (value) => Number(value) <= budgetLimit || `Le montant ne peut pas dépasser le budget restant de ${budgetLimit.toLocaleString('fr-FR')} ${projectCurrency}.`
                            }}
                            render={({ field }) => <Input type="number" {...field} placeholder="0.00" />}
                        />
                        {errors.allocated_budget && <p className="text-sm text-red-500">{errors.allocated_budget.message}</p>}
                    </div>
                    <DialogFooter>
                        <Button type="button" variant="outline" onClick={onClose}>Annuler</Button>
                        <Button type="submit" className="bg-teal-600 hover:bg-teal-700">Ajouter</Button>
                    </DialogFooter>
                </form>
            </DialogContent>
        </Dialog>
    );
}
